let selectedRequestTypes = [];
let getConfigData = {};
let rootID = "";
let requestFor = "";
let ackPage = document.getElementById("acknowledgement");
let requestSubmittedFor = document.getElementById("requestFor");
let myself = document.getElementById("myself");
let someoneelse = document.getElementById("someoneelse");
let myselfRequestTypes = document.getElementById("myselfRequestTypes");
let someoneelseRequestTypes = document.getElementById(
  "someoneelseRequestTypes"
);
let dsarForm = document.getElementById("dsar-form");
let myselfRequests = document.getElementById("myselfRequests");
let someoneelseRequests = document.getElementById("someoneelseRequests");
let updateRequestFieldMyself = document.getElementById("myself-updateRequest");
let updateRequestFieldAA = document.getElementById("someoneelse-updateRequest");
let updateRequestInputMyself = document.getElementById(
  "myselfUpdateRequestField"
);
let updateRequestInputAA = document.getElementById(
  "someoneelseUpdateRequestField"
);
let authorizedAgentAffidavit = document.getElementById(
  "authorizedAgentAffidavit"
);
let requestID = document.getElementById("requestID");
let submitButton = document.getElementById("dsar-submit");
let loader = document.getElementById("loader");
let usaStatesList = [
  "Select State",
  "Alabama",
  "Alaska",
  "American Samoa",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District Of Columbia",
  "Federated States Of Micronesia",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Marshall Islands",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Northern Mariana Islands",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Palau",
  "Pennsylvania",
  "Peurto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virgin Islands",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];
let canadaStatesList = [
  "Select Province/Territory",
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Northwest Territories",
  "Nova Scotia",
  "Nunavut",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Yukon",
];

// footer
let copyright = document.getElementById("copyright");

// region
let regionSelected = "";
let countryResidence = document.getElementById("countryResidence");

document.addEventListener("load", () => {
  copyright.innerHTML = new Date().getFullYear();
});

let selectedCheckOptions = [];
let inputValidatorMyself = {
  myselfRequestTypes: false,
  firstname: false,
  lastname: false,
  address: false,
  email: false,
  state: false,
  recaptchaToken: false,
};
let inputValidatorAA = {
  authorizedAgentEmail: false,
  authorizedAgentName: false,
  authorizedAgentRelationshipWithConsumer: false,
  someoneelseRequestTypes: false,
  consumerFirstName: false,
  consumerLastName: false,
  consumerAddress: false,
  consumerEmail: false,
  consumerState: false,
  recaptchaToken: false,
};

// Setting multiple attributes to an element
function setAttributes(ele, attrs) {
  for (var key in attrs) {
    ele.setAttribute(key, attrs[key]);
  }
}

function generateRequestTypes(configData, user) {
  const { requestTypes } = configData;

  // listing the request types from dsar-form
  requestTypes &&
    requestTypes.map((requestType) => {
      const divCol = document.createElement("div");
      divCol.setAttribute("class", "col");
      const divCard = document.createElement("div");
      divCard.setAttribute("class", "card");
      divCol.append(divCard);
      const divCardBody = document.createElement("div");
      divCardBody.setAttribute("class", "card-body");
      divCard.append(divCardBody);
      const divFormCheck = document.createElement("div");
      divFormCheck.setAttribute("class", "form-check");
      divCardBody.append(divFormCheck);
      const input = document.createElement("input");
      let idRequestType = "";
      let nameRequestType = "";
      if (user === "Myself") {
        idRequestType = `myself-${requestType.value}`;
        nameRequestType = "myselfRequestTypes";
      } else {
        idRequestType = `someoneelse-${requestType.value}`;
        nameRequestType = "someoneelseRequestTypes";
      }
      setAttributes(input, {
        type: "checkbox",
        id: idRequestType,
        value: requestType.value,
        name: nameRequestType,
        class: "form-check-input",
        onchange: "changeHandler(event)",
        required: "true",
      });
      divFormCheck.append(input);
      const label = document.createElement("label");
      label.setAttribute("class", "h6 form-check-label");
      label.setAttribute("for", idRequestType);
      const text = document.createTextNode(requestType.description);
      label.appendChild(text);
      divFormCheck.append(label);

      if (user === "Myself") {
        myselfRequestTypes.appendChild(divCol);
      } else {
        someoneelseRequestTypes.appendChild(divCol);
      }
    });
}

function handleRequestTypeChange(inputValue, nameValue) {
  let currentRequestTypes = [...selectedRequestTypes];
  if (currentRequestTypes.indexOf(inputValue) === -1) {
    currentRequestTypes = [...currentRequestTypes, inputValue];
  } else {
    currentRequestTypes = currentRequestTypes.filter(
      (requestType) => requestType !== inputValue
    );
  }
  selectedRequestTypes = currentRequestTypes;

  if (selectedRequestTypes.includes("correction")) {
    if (nameValue === "myselfRequestTypes") {
      inputValidatorMyself = {
        ...inputValidatorMyself,
        myselfUpdateRequestDetails: false,
      };
      updateRequestFieldMyself.style.display = "block";
    } else {
      inputValidatorAA = {
        ...inputValidatorAA,
        someoneelseUpdateRequestDetails: false,
      };
      updateRequestFieldAA.style.display = "block";
    }
  } else {
    updateRequestFieldMyself.style.display = "none";
    updateRequestInputMyself.value = "";
    updateRequestFieldAA.style.display = "none";
    updateRequestInputAA.input = "";
  }

  return selectedRequestTypes;
}

async function requestorRegionCheck(requestorRegion) {
  regionSelected = requestorRegion.innerText;
  const dropdownBtn = document.getElementById("dropdown-basic-button");
  dropdownBtn.innerHTML = regionSelected;
  myself.checked = false;
  someoneelse.checked = false;
  requestSubmittedFor.style.display = "block";
  dsarForm.style.display = "none";
  authorizedAgentAffidavit.style.display = "none";
}

function getStatesList(statesArray, id) {
  const stateSelect = document.getElementById(id);
  while (stateSelect.hasChildNodes()) {
    stateSelect.removeChild(stateSelect.firstChild);
  }
  for (var i = 0; i < statesArray.length; i++) {
    let option = document.createElement("option");
    if (i === 0) {
      option.value = "";
    } else {
      option.value = statesArray[i];
    }
    option.text = statesArray[i];
    stateSelect.append(option);
  }
}

// Check for the Requestor Type
async function requestorTypeCheck(californiaresident) {
  requestFor = californiaresident.value;
  if (myself.checked) {
    dsarForm.style.display = "block";
    myselfRequests.style.display = "block";
    someoneelseRequests.style.display = "none";
    authorizedAgentAffidavit.style.display = "none";

    const url =
      regionSelected === "USA"
        ? "https://wirewheel-p3-public-storage-haggar.s3.us-east-1.amazonaws.com/64e3f8bbd3470c001515074d/p3-data.json"
        : "https://wirewheel-p3-public-storage-haggar.s3.us-east-1.amazonaws.com/64e3fcc0d3470c00151508a4/p3-data.json";

    const myselfConfigData = await handleConfigData(url);

    if (!myselfRequestTypes.hasChildNodes()) {
      generateRequestTypes(myselfConfigData, requestFor);
    }

    // get states list
    let stateLabel = document.getElementById("stateLabel");
    if (regionSelected === "USA") {
      stateLabel.innerHTML = `State <span class="text-danger">*</span>`;
      // USA States
      getStatesList(usaStatesList, "state");
    } else {
      stateLabel.innerHTML = `Province/Territory <span class="text-danger">*</span>`;
      // Canada States
      getStatesList(canadaStatesList, "state");
    }
  } else if (someoneelse.checked) {
    dsarForm.style.display = "block";
    myselfRequests.style.display = "none";
    someoneelseRequests.style.display = "block";
    authorizedAgentAffidavit.style.display = "block";

    const url =
      regionSelected === "USA"
        ? "https://wirewheel-p3-public-storage-haggar.s3.us-east-1.amazonaws.com/64e3fa9cd3470c00151507f4/p3-data.json"
        : "https://wirewheel-p3-public-storage-haggar.s3.us-east-1.amazonaws.com/64ff32f7b9b58b0014594d00/p3-data.json";

    const someoneelseConfigData = await handleConfigData(url);
    const { title, docName, docURL, description } = someoneelseConfigData;

    setAttributes(document.getElementById("someoneelseAffidavit"), {
      href: docURL,
      download: docName,
    });

    document.getElementById("agentAffidavitDescription").innerHTML =
      description;
    document.getElementById("agentAffidavitTitle").innerHTML = title;

    if (!someoneelseRequestTypes.hasChildNodes()) {
      generateRequestTypes(someoneelseConfigData, requestFor);
    }

    // get states list
    let consumerStateLabel = document.getElementById("consumerStateLabel");
    if (regionSelected === "USA") {
      consumerStateLabel.innerHTML = `Consumer State <span class="text-danger">*</span>`;
      // USA States
      getStatesList(usaStatesList, "consumerState");
    } else {
      consumerStateLabel.innerHTML = `Consumer Province/Territory <span class="text-danger">*</span>`;
      // Canada States
      getStatesList(canadaStatesList, "consumerState");
    }
  } else {
    dsarForm.style.display = "none";
    myselfRequests.style.display = "none";
    someoneelseRequests.style.display = "none";
    authorizedAgentAffidavit.style.display = "none";
  }
}

// Get privacy form config details
async function handleConfigData(getUrl) {
  getConfigData = await axios.get(getUrl).then((response) => {
    let getResponseData = "";
    if (response.status === 200 && response.data) {
      if (
        response.data.attachments &&
        response.data.attachments.items.length > 0
      ) {
        const { items, header: title, description } = response.data.attachments;
        const { name: docName, linkToPublic: docURL } = items[0];
        getResponseData = {
          title,
          docName,
          docURL,
          description,
        };
      }

      const { requests, settingsId } = response.data.srrConfig;
      const actions = requests.reduce((actionsMap, request) => {
        actionsMap[request.requestType] = request;
        return actionsMap;
      }, {});

      const orderObj = {
        deletion: null,
        correction: null,
        access: null,
      };

      const finalOrderedActions = Object.assign(orderObj, actions);
      const requestTypes = Object.keys(finalOrderedActions).map((request) => {
        switch (request) {
          case "access":
            return {
              value: "access",
              description: "Access/copy of my personal information",
            };
          case "deletion":
            return {
              value: "deletion",
              description: "Delete my personal information",
            };
          case "correction":
            return {
              value: "correction",
              description: "Update/correct my personal information",
            };

          default:
            return console.warn("Unknown Request Type", request);
        }
      });
      getResponseData = {
        ...getResponseData,
        actions,
        requestTypes,
        settings: settingsId,
        _id: settingsId,
      };

      return getResponseData;
    }
  });
  return getConfigData;
}

// Handle form submit data
function handleSubmit(event) {
  event.preventDefault();
  // show loader
  ackPage.style.display = "none";
  requestSubmittedFor.style.display = "none";
  dsarForm.style.display = "none";
  authorizedAgentAffidavit.style.display = "none";
  countryResidence.style.display = "none";
  loader.style.display = "block";

  // Retreive Form Data from event
  const formData = new FormData(event.target);
  // Create an object with all the enteries in the form data
  const formProps = Object.fromEntries(formData);

  // payload
  const inputsForPayLoad = {
    selectedRequests: selectedRequestTypes,
    inputsData: formProps,
    configValues: getConfigData,
  };

  const payload = getPayload(inputsForPayLoad);

  submitRequest(payload);

  return false;
}

function getPayload({ selectedRequests, inputsData, configValues }) {
  // Get Primary Email value
  let primaryEmail =
    requestFor === "Myself"
      ? inputsData["email"]
      : inputsData["authorizedAgentEmail"];
  // Get Recaptcha value
  let recaptchaToken = inputsData["g-recaptcha-response"]
    ? inputsData["g-recaptcha-response"]
    : "";
  let providedFields = [];

  // Create providedFields array
  // assign respective values to all fields of each selected request type
  selectedRequests &&
    selectedRequests.forEach((request) => {
      for (let key in configValues.actions[request]) {
        if (key === "fields") {
          const dataFields = configValues.actions[request][key]
            .map((field) => {
              switch (field.label) {
                case "First Name":
                  return {
                    value: inputsData["firstName"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Last Name":
                  return {
                    value: inputsData["lastName"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Address":
                  return {
                    value: inputsData["address"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Phone Number":
                  return {
                    value: inputsData["phoneNumber"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Email":
                  return {
                    value:
                      inputsData["email"] || inputsData["authorizedAgentEmail"],
                    label: field.label,
                    _id: field._id,
                  };
                case "State":
                  return {
                    value: inputsData["state"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Province/Territory":
                  return {
                    value: inputsData["state"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Country":
                  return {
                    value: regionSelected,
                    label: field.label,
                    _id: field._id,
                  };
                case "Authorized Agent First and Last Name":
                  return {
                    value: inputsData["authorizedAgentName"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Authorized Agent Relationship with Consumer":
                  return {
                    value:
                      inputsData["authorizedAgentRelationshipWithConsumer"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Consumer First Name":
                  return {
                    value: inputsData["consumerFirstName"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Consumer Last Name":
                  return {
                    value: inputsData["consumerLastName"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Consumer Phone Number":
                  return {
                    value: inputsData["consumerPhoneNumber"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Consumer Email":
                  return {
                    value: inputsData["consumerEmail"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Consumer Address":
                  return {
                    value: inputsData["consumerAddress"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Consumer State":
                  return {
                    value: inputsData["consumerState"],
                    label: field.label,
                    _id: field._id,
                  };
                case "Please specify what needs to be corrected":
                  return {
                    value:
                      inputsData["myselfUpdateRequestDetails"] ||
                      inputsData["someoneelseUpdateRequestDetails"],
                    label: field.label,
                    _id: field._id,
                  };
                default:
                  console.warn(`unknown field ${field.label}`);
              }
              return null;
            })
            .filter((field) => field);

          providedFields = [...providedFields, ...dataFields];
        }
      }
    });

  // Create final data Inputs object for the Post request
  const dataInputs = {
    data: {
      providedFields,
      primaryEmail,
      providedRequests: selectedRequests,
      recaptchaToken,
    },
    meta: {
      id: `${configValues.settings}`,
      pageDataId: `${configValues._id}`,
      type: "dsar",
    },
  };
  return dataInputs;
}

// API request to submit dsar request
function submitRequest(data) {
  const url = "https://haggar.wirewheel.io/api/public/v1/self-service";
  axios
    .post(url, data)
    .then((response) => {
      if (response.status === 201 && response.data) {
        // get the root id after successful request submit
        rootID = response.data.rootId;
      }
    })
    .then(() => {
      if (rootID.length) {
        loader.style.display = "none";
        ackPage.style.display = "block";
        requestID.append(rootID);
        requestSubmittedFor.style.display = "none";
        countryResidence.style.display = "none";
        dsarForm.style.display = "none";
        authorizedAgentAffidavit.style.display = "none";
      } else {
        ackPage.style.display = "none";
        loader.style.display = "none";
        countryResidence.style.display = "block";
      }
    })
    .catch((err) => {
      console.error(err);
      // TODO: show error to user
    });
}

// Enable and Disable Submit Button
// Based on all Required fields are filled
function changeHandler(event) {
  let validatorObj = {};
  let inputValue = "";
  const { name, value } = event.target;

  if (name === "myselfRequestTypes" || name === "someoneelseRequestTypes") {
    inputValue = handleRequestTypeChange(value, name);
  } else {
    inputValue = value;
  }

  validatorObj = validate(inputValue, name);

  if (requestFor === "Myself") {
    disableSubmitButton(validatorObj.inputValidatorMyself);
  } else {
    disableSubmitButton(validatorObj.inputValidatorAA);
  }
}

// Validate input Values

function validate(value, name) {
  // Myself Fields
  const firstNameError = document.getElementById("firstName-error");
  const lastNameError = document.getElementById("lastName-error");
  const phoneNumberError = document.getElementById("phoneNumber-error");
  const emailError = document.getElementById("email-error");
  const addressError = document.getElementById("address-error");
  const stateError = document.getElementById("state-error");
  const myselfRequestTypesError = document.getElementById(
    "myselfRequestTypes-error"
  );
  const myselfUpdateRequestDetailsError = document.getElementById(
    "myselfUpdateRequestDetails-error"
  );

  // Someoneelse Fields
  const authorizedAgentEmailError = document.getElementById(
    "authorizedAgentEmail-error"
  );
  const authorizedAgentNameError = document.getElementById(
    "authorizedAgentName-error"
  );
  const authorizedAgentRelationshipWithConsumerError = document.getElementById(
    "authorizedAgentRelationshipWithConsumer-error"
  );
  const consumerFirstNameError = document.getElementById(
    "consumerFirstName-error"
  );
  const consumerLastNameError = document.getElementById(
    "consumerLastName-error"
  );
  const consumerPhoneNumberError = document.getElementById(
    "consumerPhoneNumber-error"
  );
  const consumerEmailError = document.getElementById("consumerEmail-error");
  const consumerAddressError = document.getElementById("consumerAddress-error");
  const consumerStateError = document.getElementById("consumerState-error");
  const someoneelseRequestTypesError = document.getElementById(
    "someoneelseRequestTypes-error"
  );
  const someoneelseUpdateRequestDetailsError = document.getElementById(
    "someoneelseUpdateRequestDetails-error"
  );

  if (name) {
    switch (name) {
      case "authorizedAgentEmail":
        if (value.length === 0) {
          authorizedAgentEmailError.innerHTML =
            "Authorized Agent Email is Required";
          inputValidatorAA.authorizedAgentEmail = false;
        } else if (!value.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)) {
          authorizedAgentEmailError.innerHTML =
            "Authorized Agent Email is Invalid";
          inputValidatorAA.authorizedAgentEmail = false;
        } else {
          authorizedAgentEmailError.innerHTML = "";
          inputValidatorAA.authorizedAgentEmail = true;
        }
        break;
      case "authorizedAgentName":
        if (value.length === 0) {
          authorizedAgentNameError.innerHTML =
            "Authorized Agent Name is Required";
          inputValidatorAA.authorizedAgentName = false;
        } else if (value.length < 2) {
          authorizedAgentNameError.innerHTML =
            "Authorized Agent Name should be more than 1 character";
          inputValidatorAA.authorizedAgentName = false;
        } else {
          authorizedAgentNameError.innerHTML = "";
          inputValidatorAA.authorizedAgentName = true;
        }
        break;
      case "authorizedAgentRelationshipWithConsumer":
        if (value.length === 0) {
          authorizedAgentRelationshipWithConsumerError.innerHTML =
            "Authorized Agent Relationship with Consumer is Required";
          inputValidatorAA.authorizedAgentRelationshipWithConsumer = false;
        } else if (value.length < 2) {
          authorizedAgentRelationshipWithConsumerError.innerHTML =
            "Authorized Agent Relationship with Consumer should be more than 1 character";
          inputValidatorAA.authorizedAgentRelationshipWithConsumer = false;
        } else {
          authorizedAgentRelationshipWithConsumerError.innerHTML = "";
          inputValidatorAA.authorizedAgentRelationshipWithConsumer = true;
        }
        break;
      case "consumerFirstName":
        if (value.length === 0) {
          consumerFirstNameError.innerHTML = "Consumer First Name is Required";
          inputValidatorAA.consumerFirstName = false;
        } else if (value.length < 2) {
          consumerFirstNameError.innerHTML =
            "Consumer First Name should be more than 1 character";
          inputValidatorAA.consumerFirstName = false;
        } else {
          consumerFirstNameError.innerHTML = "";
          inputValidatorAA.consumerFirstName = true;
        }
        break;
      case "consumerLastName":
        if (value.length === 0) {
          consumerLastNameError.innerHTML = "Consumer Last Name is Required";
          inputValidatorAA.consumerLastName = false;
        } else if (value.length < 2) {
          consumerLastNameError.innerHTML =
            "Consumer Last Name should be more than 1 character";
          inputValidatorAA.consumerLastName = false;
        } else {
          consumerLastNameError.innerHTML = "";
          inputValidatorAA.consumerLastName = true;
        }
        break;
      case "consumerPhoneNumber":
        if (value.length < 10) {
          consumerPhoneNumberError.innerHTML =
            "Consumer Phone Number is Invalid";
        } else if (!value.match(/\(?\d{3}\)?-? *\d{3}-? *-?\d{4}/)) {
          consumerPhoneNumberError.innerHTML =
            "Consumer Phone Number is Invalid";
        } else {
          consumerPhoneNumberError.innerHTML = "";
        }
        break;
      case "consumerAddress":
        if (value.length === 0) {
          consumerAddressError.innerHTML = "Consumer Address is Required";
          inputValidatorAA.consumerAddress = false;
        } else {
          consumerAddressError.innerHTML = "";
          inputValidatorAA.consumerAddress = true;
        }
        break;
      case "consumerEmail":
        if (value.length === 0) {
          consumerEmailError.innerHTML = "Consumer Email is Required";
          inputValidatorAA.consumerEmail = false;
        } else if (!value.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)) {
          consumerEmailError.innerHTML = "Consumer Email is Invalid";
          inputValidatorAA.consumerEmail = false;
        } else {
          consumerEmailError.innerHTML = "";
          inputValidatorAA.consumerEmail = true;
        }
        break;
      case "consumerState":
        if (value.length === 0) {
          consumerStateError.innerHTML = "Consumer State is Required";
          inputValidatorAA.consumerState = false;
        } else {
          consumerStateError.innerHTML = "";
          inputValidatorAA.consumerState = true;
        }
        break;
      case "firstName":
        if (value.length === 0) {
          firstNameError.innerHTML = "First Name is Required";
          inputValidatorMyself.firstname = false;
        } else if (value.length < 2) {
          firstNameError.innerHTML =
            "First Name should be more than 1 character";
          inputValidatorMyself.firstname = false;
        } else {
          firstNameError.innerHTML = "";
          inputValidatorMyself.firstname = true;
        }
        break;
      case "lastName":
        if (value.length === 0) {
          lastNameError.innerHTML = "Last Name is Required";
          inputValidatorMyself.lastname = false;
        } else if (value.length < 2) {
          lastNameError.innerHTML = "Last Name should be more than 1 character";
          inputValidatorMyself.lastname = false;
        } else {
          lastNameError.innerHTML = "";
          inputValidatorMyself.lastname = true;
        }
        break;
      case "phoneNumber":
        if (value.length < 10) {
          phoneNumberError.innerHTML = "Phone Number is Invalid";
        } else if (!value.match(/\(?\d{3}\)?-? *\d{3}-? *-?\d{4}/)) {
          phoneNumberError.innerHTML = "Phone Number is Invalid";
        } else {
          phoneNumberError.innerHTML = "";
        }
        break;
      case "address":
        if (value.length === 0) {
          addressError.innerHTML = "Address is Required";
          inputValidatorMyself.address = false;
        } else {
          addressError.innerHTML = "";
          inputValidatorMyself.address = true;
        }
        break;
      case "myselfRequestTypes":
        if (value.length === 0) {
          myselfRequestTypesError.innerHTML =
            "Please select any of the above Request Types";
          inputValidatorMyself.myselfRequestTypes = false;
        } else {
          myselfRequestTypesError.innerHTML = "";
          inputValidatorMyself.myselfRequestTypes = true;
        }
        break;
      case "someoneelseRequestTypes":
        if (value.length === 0) {
          someoneelseRequestTypesError.innerHTML =
            "Please select any of the above Request Types";
          inputValidatorAA.someoneelseRequestTypes = false;
        } else {
          someoneelseRequestTypesError.innerHTML = "";
          inputValidatorAA.someoneelseRequestTypes = true;
        }
        break;
      case "myselfUpdateRequestDetails":
        if (value.length === 0) {
          myselfUpdateRequestDetailsError.innerHTML =
            "Please specify the details";
          inputValidatorMyself.myselfUpdateRequestDetails = false;
        } else {
          myselfUpdateRequestDetailsError.innerHTML = "";
          inputValidatorMyself.myselfUpdateRequestDetails = true;
        }
        break;
      case "someoneelseUpdateRequestDetails":
        if (value.length === 0) {
          someoneelseUpdateRequestDetailsError.innerHTML =
            "Please specify the details";
          inputValidatorAA.someoneelseUpdateRequestDetails = false;
        } else {
          someoneelseUpdateRequestDetailsError.innerHTML = "";
          inputValidatorAA.someoneelseUpdateRequestDetails = true;
        }
        break;
      case "state":
        if (value.length === 0) {
          stateError.innerHTML = "State is Required";
          inputValidatorMyself.state = false;
        } else {
          stateError.innerHTML = "";
          inputValidatorMyself.state = true;
        }
        break;
      case "email":
        if (value.length === 0) {
          emailError.innerHTML = "Email is Required";
          inputValidatorMyself.email = false;
        } else if (!value.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)) {
          emailError.innerHTML = "Email is Invalid";
          inputValidatorMyself.email = false;
        } else {
          emailError.innerHTML = "";
          inputValidatorMyself.email = true;
        }
        break;

      default:
        break;
    }
  }
  return { inputValidatorMyself, inputValidatorAA };
}

// Disable Submit Button
function disableSubmitButton(validatorObject) {
  let disableBtn = Object.keys(validatorObject).every((item) => {
    return validatorObject[item] === true;
  });

  if (disableBtn) {
    submitButton.removeAttribute("disabled");
  } else {
    submitButton.setAttribute("disabled", "disabled");
  }
}

// Recaptcha callback

function recaptchaCallBack(response) {
  if (response) {
    if (requestFor && requestFor === "Myself") {
      inputValidatorMyself.recaptchaToken = true;
      disableSubmitButton(inputValidatorMyself);
    } else {
      inputValidatorAA.recaptchaToken = true;
      disableSubmitButton(inputValidatorAA);
    }
  }
}

function onRecaptchaResponseExpiry() {
  if (requestFor && requestFor === "Myself") {
    inputValidatorMyself.recaptchaToken = false;
    disableSubmitButton(inputValidatorMyself);
  } else {
    inputValidatorAA.recaptchaToken = false;
    disableSubmitButton(inputValidatorAA);
  }
}
